import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import { withRouter, Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, Col, Container, Row, Modal, Button, ModalHeader, ModalBody, FormGroup, Alert } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { AvForm, AvField } from 'availity-reactstrap-validation';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { getAgents, addAgent, updateAgent, deleteAgent } from '../../store/transfers/actions';

import PageLoader from '../../components/Loaders/pageLoader';

class AgentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agent: [],
      modal: false,
      isEdit: false,
      error: '',
      alert: null,
      AgentsListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          hidden: true,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Name',
          dataField: 'name',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, agent) => (
            <>
              <p className='text-muted font-size-14 mb-0'>{agent.mainName}</p>
              <h5 className='font-size-16 mb-1'>{agent.name}</h5>
            </>
          )
        },
        {
          text: 'Address',
          dataField: 'address',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, agent) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1 '>{agent.address}</h5>
            </div>
          )
        },
        {
          text: 'Phone',
          dataField: 'phone',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, agent) => <h5 className='font-size-16 mb-1 '>{agent.phone}</h5>
        },
        {
          text: 'Comments',
          dataField: 'commentsAddress',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: true,
          formatter: (cellContent, agent) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1 '>{agent.commentsAddress}</h5>
            </div>
          )
        },
        {
          dataField: 'menu',
          text: 'Action',
          editable: false,
          formatter: (cellContent, agent) => (
            <div className='d-flex gap-3'>
              <ReactTooltip place='bottom' type='info' effect='solid' multiline={true} />
              {this.props.profileData.permissions.includes('transferAgentTableEdit') && (
                <>
                  {agent.onVacation === false && agent.onPause === false && (
                    <Link className='text-success' to='#'>
                      <i className='mdi font-size-18' id='edittooltip' data-tip='Working' onClick={(e) => this.handleOnVacation('vacation on', agent)}>
                        Working
                      </i>
                    </Link>
                  )}
                  {agent.onVacation === true && agent.onPause === false && (
                    <Link className='text-danger' to='#'>
                      <i className='mdi font-size-18' id='edittooltip' data-tip='on Vacation' onClick={(e) => this.handleOnVacation('vacation off', agent)}>
                        On Vacation
                      </i>
                    </Link>
                  )}
                  {agent.onPause === true && (
                    <Link className='text-primary' to='#'>
                      <i
                        className='mdi font-size-18'
                        id='edittooltip'
                        // onClick={(e) => this.handleOnVacation('vacation off', agent)}
                      >
                        On Pause
                      </i>
                    </Link>
                  )}
                  <Link className='text-success' to='#'>
                    <i className='mdi mdi-pencil font-size-18' id='edittooltip' onClick={(e) => this.handleEditAgentClick(agent)}></i>
                  </Link>
                  {agent.onPause === false && (
                    <Link className='text-primary' to='#'>
                      <i className='mdi mdi-pause font-size-18' id='edittooltip' onClick={(e) => this.handleOnVacation('pause on', agent)}></i>
                    </Link>
                  )}
                  {agent.onPause === true && (
                    <Link className='text-primary' to='#'>
                      <i className='mdi mdi-play font-size-18' id='edittooltip' onClick={(e) => this.handleOnVacation('pause off', agent)}></i>
                    </Link>
                  )}
                  <Link className='text-danger' to='#'>
                    <i className='mdi mdi-delete font-size-18' id='deletetooltip' onClick={() => this.handleDeleteAgent(agent)}></i>
                  </Link>
                </>
              )}
            </div>
          )
        }
      ],
      FeesListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          hidden: true,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Box Size',
          dataField: 'boxSize',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, fee) => (
            <h5 className='font-size-16 mb-1'>
              {fee.boxSize}
              <i className='bx bx-chevron-down-square ms-1' />
            </h5>
          )
        },
        {
          text: 'Weight',
          dataField: 'weightKG',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, fee) => <h5 className='font-size-16 mb-1 '>{fee.weightKG}kg</h5>
        },
        {
          text: 'Agent Fee',
          dataField: 'agentFee',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, fee) => <h5 className='font-size-16 mb-1 '>{fee.agentFee}$</h5>
        }
        //  {
        //    dataField: 'menu',
        //    text: 'Action',
        //    editable: false,
        //    formatter: (cellContent, fee) => (
        //      <div className='d-flex gap-3'>
        //        {this.state.profile.transferAgentTableEdit && (
        //          <>
        //            <Link className='text-success' to='#'>
        //              <i
        //                className='mdi mdi-pencil font-size-18'
        //                id='edittooltip'
        //                onClick={(e) => this.handleEditAgent(fee)}
        //              ></i>
        //            </Link>
        //            <Link className='text-danger' to='#'>
        //              <i
        //                className='mdi mdi-delete font-size-18'
        //                id='deletetooltip'
        //                onClick={() => this.handleDeleteAgentRow(fee)}
        //              ></i>
        //            </Link>
        //          </>
        //        )}
        //      </div>
        //    )
        //  }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.indication = this.indication.bind(this);

    this.toggle = this.toggle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);

    this.handleAgentClickNew = this.handleAgentClickNew.bind(this);
    this.handleEditAgentClick = this.handleEditAgentClick.bind(this);
    this.handleNewAgentSubmit = this.handleNewAgentSubmit.bind(this);
    this.handleOnVacation = this.handleOnVacation.bind(this);

    this.handleDeleteAgent = this.handleDeleteAgent.bind(this);
  }
  componentDidMount() {
    const { onGetAgents } = this.props;
    onGetAgents();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('resize', this.getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * Get screen height of the table
   * @param {*} click
   */
  getScreenHeight = (click) => {
    if (document.getElementById('card-section')) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - 74px); overflow: auto;');
    }
  };
  /**
   * Clear array, Open modal
   */
  handleAgentClickNew = () => {
    this.setState({ agent: [], error: '', isEdit: false });
    this.toggle();
  };
  /**
   * Assign data from table to selected agent for edit
   * @param {array} agent selected agent info
   */
  handleEditAgentClick = (agent) => {
    this.setState({
      agent: {
        _id: agent._id,
        mainName: agent.mainName,
        name: agent.name,
        phone: agent.phone,
        address: agent.address,
        commentsAddress: agent.commentsAddress
      },
      isEdit: true,
      error: ''
    });
    this.toggle();
  };

  /**
   *
   * @returns Open/close modal
   */
  toggle = () => this.setState((prevState) => ({ modal: !prevState.modal }));
  /**
   * Display empty table
   * @returns empty message if no results are found
   */
  indication = () => {
    let emptyMessage = '';
    if (this.props.agents.length !== 0 && this.props.agents[0]['manager'] === 'No Results Found') {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };

  handleNewAgentSubmit = (e, values) => {
    const { onAddAgent, onUpdateAgent } = this.props;
    const { isEdit, agent } = this.state;
    if (isEdit) {
      const updateAgent = {
        _id: agent._id,
        mainName: values.mainName,
        name: values.name,
        phone: values.phone,
        address: values.address,
        commentsAddress: values.commentsAddress
      };
      // update agent
      onUpdateAgent(updateAgent);
    } else {
      const newAgent = {
        mainName: values['mainName'],
        name: values['name'],
        phone: values['phone'],
        address: values['address'],
        commentsAddress: values['commentsAddress']
      };
      // add new agent
      onAddAgent(newAgent);
    }
    this.setState({ error: '' });
    this.toggle();
  };

  handleOnVacation = (option, agent) => {
    const { onUpdateAgent } = this.props;
    let updateAgent = [];
    if (option === 'vacation on' || option === 'vacation off') {
      updateAgent = {
        _id: agent._id,
        onVacation: option === 'vacation on' ? true : false
      };
    } else if (option === 'pause on' || option === 'pause off') {
      updateAgent = {
        _id: agent._id,
        onPause: option === 'pause on' ? true : false
      };
    }
    onUpdateAgent(updateAgent);
  };
  /**
   * Call alert before delete
   * @param {array} agent
   */
  handleDeleteAgent = (agent) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert(agent._id)}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        <p className='fw-bold'>{agent.mainName}</p> will be deleted from the system!
      </SweetAlert>
    );
    this.setState({ alert: getAlert() });
  };
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null });
  /**
   * Delete department from database
   * @param {array} department
   */
  deleteAlert(id) {
    const { onDeleteAgent } = this.props;
    onDeleteAgent(id);
    this.setState({
      alert: null
    });
  }
  render() {
    const { SearchBar } = Search;
    const { agents, fees, loading, profileData } = this.props;
    const { isEdit, modal, alert, agent, AgentsListColumns, FeesListColumns } = this.state;
    const pageOptions = {
      sizePerPage: agents.length,
      totalSize: agents.length, // replace later with size(users),
      custom: true
    };
    const pageOptionsFees = {
      sizePerPage: fees.length,
      totalSize: fees.length, // replace later with size(users),
      custom: true
    };
    const defaultSorted = [
      {
        dataField: '_id', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>}
        <div className='page-content'>
          <MetaTags>
            <title>Agents Information </title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('transferAgentAccess') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title='Transfers' breadcrumbItem='Agents Info' />
                <Row id='card-section'>
                  <Col lg='8'>
                    <Card>
                      <CardBody>
                        <PaginationProvider pagination={paginationFactory(pageOptions)} keyField='_id' columns={AgentsListColumns} data={agents}>
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider keyField='_id' columns={AgentsListColumns} data={agents} search>
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row className='mb-2'>
                                    <Col sm='4'>
                                      <div className='search-box ms-2 mb-2 d-inline-block'>
                                        <div className='position-relative'>
                                          <SearchBar {...toolkitprops.searchProps} />
                                          <i className='bx bx-search-alt search-icon' />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col sm='8'>
                                      <div className='text-sm-end'>
                                        <Button color='primary' className='font-16 btn-block btn btn-primary btn-lg' onClick={this.handleAgentClickNew}>
                                          <i className='mdi mdi-plus-circle-outline me-1' />
                                          Add New Agent
                                        </Button>
                                        <Modal size='lg' isOpen={modal} className={this.props.className} toggle={this.toggle}>
                                          <ModalHeader toggle={this.toggle} tag='h4'>
                                            {!!isEdit ? 'Edit Agent Info' : 'Add New agent'}
                                          </ModalHeader>
                                          <ModalBody>
                                            <AvForm onValidSubmit={this.handleNewAgentSubmit}>
                                              <Row>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='mainName'
                                                      label='Main Name'
                                                      type='text'
                                                      errorMessage='Invalid Name'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={agent.mainName || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='name'
                                                      label='Name'
                                                      type='text'
                                                      errorMessage='Invalid Name'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={agent.name || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='phone'
                                                      label='Phone'
                                                      type='text'
                                                      errorMessage='Invalid phone'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={agent.phone || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      name='address'
                                                      label='Address'
                                                      type='textarea'
                                                      className='font-size-20'
                                                      rows={5}
                                                      errorMessage='Invalid address'
                                                      validate={{
                                                        required: {
                                                          value: true
                                                        }
                                                      }}
                                                      value={agent.address || ''}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField name='commentsAddress' label='Comments' type='textarea' className='font-size-20' rows={5} value={agent.commentsAddress || ''} />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  <div className='text-end'>
                                                    <button type='submit' className='btn btn-success save-user'>
                                                      {!!isEdit ? 'Edit Agent Info' : 'Add New Agent'}
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </AvForm>
                                          </ModalBody>
                                        </Modal>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xl='12'>
                                      <div className='table-responsive'>
                                        <BootstrapTable
                                          {...toolkitprops.baseProps}
                                          {...paginationTableProps}
                                          defaultSorted={defaultSorted}
                                          noDataIndication={this.indication}
                                          classes={'table align-middle table-nowrap'}
                                          headerClasses='header-class is-sticky-hdr'
                                          id='tableScroll'
                                          bordered={true}
                                          // striped={true}
                                          responsive
                                        />
                                        {alert}
                                      </div>
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg='4'>
                    <Card>
                      <CardBody>
                        <PaginationProvider pagination={paginationFactory(pageOptionsFees)} keyField='_id' columns={FeesListColumns} data={fees}>
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider keyField='_id' columns={FeesListColumns} data={fees} search>
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row>
                                    <Col xl='12'>
                                      <div className='table-responsive'>
                                        <BootstrapTable
                                          {...toolkitprops.baseProps}
                                          {...paginationTableProps}
                                          defaultSorted={defaultSorted}
                                          classes={'table align-middle table-nowrap'}
                                          headerClasses='header-class is-sticky-hdr'
                                          id='tableScroll'
                                          bordered={true}
                                          // striped={true}
                                          responsive
                                        />
                                        {alert}
                                      </div>
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AgentsList.propTypes = {
  agents: PropTypes.array,
  fees: PropTypes.array,
  onGetAgents: PropTypes.func,
  onAddAgent: PropTypes.func,
  onUpdateAgent: PropTypes.func,
  onDeleteAgent: PropTypes.func
};

const mapStateToProps = ({ transfers }) => ({
  agents: transfers.agents,
  fees: transfers.fees,
  loading: transfers.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetAgents: () => dispatch(getAgents()),
  onAddAgent: (agent) => dispatch(addAgent(agent)),
  onUpdateAgent: (agent) => dispatch(updateAgent(agent)),
  onDeleteAgent: (agent) => dispatch(deleteAgent(agent))
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AgentsList));
